import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ChipService {
  constructor(private http: HttpClient) {}

  public getUserEmailForChipNumber(chipNumber: string): Observable<HttpResponse<string>> {
    return this.http.get(`${environment.apiUrl}/api/v2/chips/${chipNumber}/user`, { observe: 'response', responseType: 'text' });
  }
};
